import { useTranslation } from 'react-i18next';
import Button from '~/components/buttons/NewButton';
import { useActiveCompanyId } from '~/hooks/useActiveCompany';
import IconDownload from '~/icons/icon-download.svg?react';
import { BookkeepingAdjustmentTypeFilter, bookkeepingAdjustmentGroupToTypes } from '~/types/general-bookkeeping';
import { formatDateForAPI } from '~/utils/formatDate';
import {
  useAdjustmentGroupsFilter,
  useDateFilter,
  useIsExportingJournalPDF,
} from '~/views/bookkeeping/cash-book/cash-book-state';
import { useGeneralJournalPDFExport } from './useGeneralJournalPDFExport';

const ExportGeneralJournalPDFButton: React.FC = () => {
  const { t } = useTranslation('bookkeeping', { keyPrefix: 'general_bookkeeping.cash_book' });
  const [dateRange] = useDateFilter();
  const [adjustmentGroups] = useAdjustmentGroupsFilter();
  const companyId = useActiveCompanyId();
  const isExporting = useIsExportingJournalPDF();
  const { exportPDF } = useGeneralJournalPDFExport();

  const handleClick = () => {
    if (!dateRange) return;
    const adjustmentType: BookkeepingAdjustmentTypeFilter[] = [
      'NONE',
      ...adjustmentGroups.flatMap((group) => bookkeepingAdjustmentGroupToTypes[group]),
    ];
    exportPDF(companyId, formatDateForAPI(dateRange.start), formatDateForAPI(dateRange.end), adjustmentType);
  };

  return (
    <Button
      data-testid="export-general-journal-pdf-button"
      disabled={!dateRange || isExporting}
      loading={isExporting}
      onClick={handleClick}
      Icon={IconDownload}
      variant="outlined"
    >
      {t('export_journal_pdf')}
    </Button>
  );
};

export default ExportGeneralJournalPDFButton;
